import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import { CodexTerminalFrame } from "../ui/CodexTerminalFrame";

const frames = [
  {
    prompt: "> build home surface and ship the frontend route",
    lines: [
      { tone: "muted", text: "ui.build vite bundle updated" },
      { tone: "mint", text: "native host inlined assets into the webview surface" },
      { tone: "violet", text: "home route ready for launch actions" },
    ],
  },
  {
    prompt: "> inspect src/native_shell/app.rs and split surface ownership",
    lines: [
      { tone: "muted", text: "workspace.scan app.rs html.rs surfaces/ ui_host.rs" },
      { tone: "mint", text: "home and tools already moved off the direct html path" },
      { tone: "amber", text: "next move: chat + files migration and cleanup" },
    ],
  },
  {
    prompt: "> trace browser, codex, and host lanes together",
    lines: [
      { tone: "muted", text: "host.os prompt ready" },
      { tone: "violet", text: "project.codex drafting reply" },
      { tone: "mint", text: "browser.codex context bridge active" },
    ],
  },
];

export function HeroTerminal() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % frames.length);
    }, 3400);
    return () => window.clearInterval(timer);
  }, []);

  const frame = frames[index];

  return (
    <CodexTerminalFrame title="runtime preview" prompt={frame.prompt} className="hero-terminal" compact>
      <AnimatePresence mode="wait">
        <motion.div
          key={frame.prompt}
          className="hero-terminal__stream"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.28, ease: "easeOut" }}
        >
          {frame.lines.map((line) => (
            <motion.div
              key={line.text}
              className={`hero-terminal__line hero-terminal__line--${line.tone}`}
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.24, ease: "easeOut" }}
            >
              {line.text}
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>
    </CodexTerminalFrame>
  );
}
